import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const block = {
  createBlockArticle: lazyModuleMethod(
    () => import('./createBlockArticle'),
    'default'
  ),
  fetchBlockArticle: lazyModuleMethod(
    () => import('./fetchBlockArticle'),
    'default'
  ),
  fetchBlockByCode: lazyModuleMethod(
    () => import('./fetchBlockByCode'),
    'default'
  ),
  fetchBlocks: lazyModuleMethod(() => import('./fetchBlocks'), 'default'),
  updateBlock: lazyModuleMethod(() => import('./updateBlock'), 'default'),
  updateBlockArticle: lazyModuleMethod(
    () => import('./updateBlockArticle'),
    'default'
  ),
  deleteBlockArticle: lazyModuleMethod(
    () => import('./deleteBlockArticle'),
    'default'
  ),
  updateMassBlockArticles: lazyModuleMethod(
    () => import('./updateMassBlockArticles'),
    'default'
  ),
}
